import { RichText } from "@/components/RichText";
import type { SteerBrain as Data } from "@/lib/types";

export default function SteerBrain({ data }: { data: Data }) {
  return (
    <section className="steerbrain" id="brain">
      <div className="steerbrain-inner">
        <div>
          <div className="sb-eyebrow">{data.eyebrow}</div>
          <RichText as="h2" className="sb-title display" html={data.title} />
          <p className="sb-desc">{data.desc}</p>
          <div className="sb-features">
            {data.features.map((f) => (
              <div className="sb-feature" key={f.title}>
                <div className="sb-feature-dot" />
                <div className="sb-feature-text">
                  <strong>{f.title}</strong> {f.body}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="sb-visual" aria-hidden="true">
          <div className="sb-big-stat">
            <div className="sb-big-num">{data.bigNum}</div>
            <div className="sb-big-label">{data.bigLabel}</div>
          </div>
          <div className="sb-rings">
            <div className="sb-ring" />
            <div className="sb-ring" />
            <div className="sb-ring" />
          </div>
        </div>
      </div>
    </section>
  );
}
